import { PermissionType } from 'enums/permissionType.enum';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from 'queries';
import { getDefaultLandingPageUrl } from 'router/getDefaultLandingPageUrl';

export const HomePage = () => {
  const navigate = useNavigate();
  const { data: user, isInitialLoading } = useGetUser();

  useEffect(() => {
    if (isInitialLoading) {
      return;
    }

    const userRoles: PermissionType[] = user?.roles.map(r => r.role.type) ?? [];
    navigate(getDefaultLandingPageUrl(userRoles), { replace: true });
  }, [isInitialLoading, navigate, user]);

  return (
    <div>
      <h3>Home</h3>
    </div>
  );
};
